module.exports = __webpack_public_path__ + "img/CharismaBoost.686240d3.png";